// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getIsShareEntity } from "@insite/client-framework/ServerSideRendering";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { FC, useEffect } from "react";
import { connect } from "react-redux";

const cludoSearchSettings = {
    customerId: 390,
    engineId: 1984,
    language: "en",
    googleAnalyticsTrackingId: "UA-42573446-1",
    type: "standardOverlay",
};

const mapStateToProps = (state: ApplicationState) => {
    const cludoSettings = getSettingsCollection(state)?.cluedoSettings;
    return {
        customerId: (cludoSettings as any)?.customerId,
        engineId: (cludoSettings as any)?.engineId,
        language: (cludoSettings as any)?.language,
        googleAnalyticsTrackingId: (cludoSettings as any)?.googleAnalyticsTrackingId,
        type: (cludoSettings as any)?.type,
    };
};

type Props = ReturnType<typeof mapStateToProps>;

const CludoSearchComponent: FC<Props> = ({ customerId, engineId, language, googleAnalyticsTrackingId, type }) => {
    useEffect(() => {
        if (!getIsShareEntity() && !IS_SERVER_SIDE && (window as any).Cludo) {
            const cludoSettings = {
                customerId: customerId || cludoSearchSettings.customerId,
                engineId: engineId || cludoSearchSettings.engineId,
                language: language || cludoSearchSettings.language,
                searchInputs: ["cludo-search-form", "cludo-search-form-mobile", "cludo-search-form-not-found"],
                googleAnalyticsTrackingId: googleAnalyticsTrackingId || cludoSearchSettings.googleAnalyticsTrackingId,
                type: type || cludoSearchSettings.type,
            };
            const CludoSearch = new (window as any).Cludo(cludoSettings);
            CludoSearch.init();
        }
    }, []);
    return null;
};

export default connect(mapStateToProps)(CludoSearchComponent);
